import React from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import { FaGift, FaStar, FaGem } from 'react-icons/fa'; // Importamos los iconos
import './PlanSection.css';
const PlanSection = () => {
  return (
    <div className="pricing-plans-section">
      <h2>Elige tu Plan</h2>
      <Row className="justify-content-center">
        <Col md={4}>
          <Card className="pricing-card">
            <Card.Body>
              <FaGift className="pricing-icon" />
              <Card.Title>Plan Individual</Card.Title>
              <Card.Text>
                <strong>$25/ hora</strong>
              </Card.Text>
              <ul>
                <li>✔ Clases individuales de inglés por hora</li>
                <li>✔ Acceso a la biblioteca de recursos de inglés</li>
                <li>✖ Sin descuento adicional</li>
              </ul>
              <Button variant="light" className="book-now-btn">Agendar</Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="pricing-card featured-plan">
            <Card.Body>
              <FaStar className="pricing-icon" />
              <Card.Title>Plan Paquete</Card.Title>
              <Card.Text>
                <strong>$20/ clase</strong>
              </Card.Text>
              <ul>
                <li>✔ Paquete de 20 clases individuales</li>
                <li>✔ Acceso a la biblioteca de recursos de inglés</li>
                <li>✖ Sin descuento adicional</li>
              </ul>
              <Button variant="light" className="book-now-btn">Agendar</Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="pricing-card">
            <Card.Body>
              <FaGem className="pricing-icon" />
              <Card.Title>Plan Colectivo</Card.Title>
              <Card.Text>
                <strong>$15/ clase</strong>
              </Card.Text>
              <ul>
                <li>✔ Clases grupales de inglés</li>
                <li>✔ Acceso a la biblioteca de recursos de inglés</li>
                <li>✔ Descuento adicional</li>
              </ul>
              <Button variant="light" className="book-now-btn">Agendar</Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PlanSection;
